import React, {Fragment} from 'react';
import {faRotate} from "@fortawesome/free-solid-svg-icons";
import FormHeader from "../../Common/FormHeader";
import ListTable from "../../Common/ListTable";
import {
    languageOptionsObject,
    statusOptionsObject,
    categoryOptionsObject,
    cratioStatusOptions, cratioStatusFilterOptions,
} from "./Constants";
import {
    syncTemplates, processSelectList, loadCustomFormData, decodeString, handleErrorResponse,
    getWAComponents,
    parseJSON,
    showToast
} from "../../Common/Appcommon";
import requestApi from "../../services/requestApi.service";
import Footer from '../../Layout/AppFooter';
import CratioTooltip from '../../Common/CratioTooltip';
import {faCirclePlus} from "@fortawesome/free-solid-svg-icons/faCirclePlus";
import MediaModal from './MediaModal';
import CarouselModal from './CarouselModal';
import requestApiService from '../../services/requestApi.service';

class Templates extends React.Component {

    formname = process.env.REACT_APP_TEMPLATES_FORMNAME;
    statusOptions = [];
    categoryOptions = [];
    constructor(props) {
        super(props);

        this.state = {
            showLoader : false,
            page:1,
            limit: process.env.REACT_APP_RECORDS_PER_PAGE,
            totalCount: 0,
            formData: [],
            listFields : [],
            searchTxt : [],
            filterTxt : [],
            dateFilter : [],
            otherInfo : [],
            langOptions : [],
            showMediaModal : false,
            showCarouselModal : false,
            editTemplate : {},
        };
    }

    componentDidMount = async () => {
        this.setState({
            showLoader : true
        })
        let selectedOptions = {
            label: 'All Active', value: 'ACTIVE'
        };
        let { filterTxt } = this.state;
        filterTxt = await processSelectList(filterTxt,"Cratio_Status",selectedOptions, false);
        this.setState({ filterTxt },async ()=>{
            await this.loadFormData(true);
        });
        //await this.loadFormData();
        this.setState({
            showLoader : false
        })
    };

    loadFormData = async (issearch=false) => {

        const { rowData , listFields, totalCount, otherInfo } =
            await loadCustomFormData(
                issearch,
                this.formname,
                this.state
            );
        let langOptions = [];
        if(otherInfo !== undefined && otherInfo.length > 0){
            let langGroup = otherInfo[0];
            let statusGroup = otherInfo[1];
            let categoryGroup = otherInfo[2];
            let langObject = languageOptionsObject;
            for(let oi in langGroup) {
                let langvalue = langGroup[oi][0];
                if(langObject[langvalue] !== undefined){
                    langOptions.push({
                        label: langObject[langvalue], value: langvalue
                    });
                }
            }

            this.statusOptions = [];
            for(let oi in statusGroup) {
                let status = statusGroup[oi][0];
                let statusObject = statusOptionsObject;
                if(statusObject[status] !== undefined){
                    this.statusOptions.push({
                        label: statusObject[status], value: status, group: "Status"
                    });
                }
            }

            this.categoryOptions = [];
            for(let oi in categoryGroup) {
                let category = categoryGroup[oi][0];
                let categoryObject = categoryOptionsObject;
                if(categoryObject[category] !== undefined){
                    this.categoryOptions.push({
                        label: categoryObject[category], value: category
                    });
                }
            }
        }

        this.setState({
            formData: rowData,
            listFields : listFields,
            totalCount : totalCount,
            otherInfo : otherInfo,
            langOptions : langOptions,
        })
    }

    handleSearch = async (name,value) => {

        let { searchTxt } = this.state;

        searchTxt[name] = value;

        this.setState({searchTxt},async ()=>{
            await this.loadFormData(true);
        })
    }

    handleChange = async (name,selectedOptions, isMultiple = false) => {

        let { filterTxt } = this.state;
        filterTxt = await processSelectList(filterTxt,name,selectedOptions, isMultiple);
        this.setState({ filterTxt },async ()=>{
            await this.loadFormData(true);
        });
    }

    handleBtnClick = async (name,e) => {
        if(name == 'sync_templates'){
            await this.syncUpdatedTemplates();
        }else if(name === 'create_template'){
            this.openUrlInNewTab(`https://business.facebook.com/wa/manage/message-templates/`);
        }else if(name === 'create_carousel_template'){
            this.setState({ editTemplate: {} }, () => {
                this.toggleCarouselModal();
            });
        }
    }

    openUrlInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null
    }


    syncUpdatedTemplates = async () => {

        this.setState({
            showLoader : true
        })

       await syncTemplates();

        await this.loadFormData();

        this.setState({
            showLoader : false
        })
   };

    onPageChange = async (page) => {
        this.setState({page},async ()=>{
            await this.loadFormData();
        });
    }

    updateTemplateValue = async (fields, formId) => {
        let data = {"Cratio_Status" : fields};
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION" : 'TEMPLATES_UPDATE',
            "FORMINPUT" : data,
            "isOtherApiReq" : true,
            "FORMNAME" : this.formname,
            "FORMID" : formId,
        }
        let res = await requestApi.processServerRequest(params,"WebV2","post");
        if(res.issuccess){
            this.loadFormData();
        }else{
            handleErrorResponse(res.errormsg);
        }
    }

    renderElements =  (name,formData,fields,childprops,childstate) => {

        if(name === 'groupName'){
            let nameValue = formData['Name'];
            let category = formData['Category'];

            return (
                <>
                    <div className={`d-grid text-left`}>
                        <span className={'template-primary'}>{nameValue}</span>
                        <span className={'template-secondary'}>{category}</span>
                    </div>
                </>
            )
        }
        if(name === 'msgGroup'){
            let message = formData['Message'];
            if(message !== "") {
                message = decodeString(message,true);
                if(typeof(message) === "string"){
                    message = message.replace(/\\n/g, '');
                }else{
                    message = "";
                }
            }
            return (
                <>
                    <div className={`d-grid text-left`}>
                        <span className={'template-primary'}>{message}</span>
                    </div>
                </>
            )
        }
        if(name === 'language_value'){
            let language = formData['Language'];
            language = languageOptionsObject[language] !== undefined ? languageOptionsObject[language] : language;
            return (
                <>
                    <div className={`d-grid text-left`}>
                        <span className={'template-primary'}>{language}</span>
                    </div>
                </>
            )
        }
        if(name === 'status_allocate'){
            let status = formData['Status'];
            let cratioStatus = formData['Cratio_Status'];
            return (
                <>
                    <div className={`d-grid text-center`}>
                        <span className={'template-primary'}>{cratioStatus}</span>
                        <CratioTooltip title={"META STATUS"} id={"Status_"} content={<span className={'template-secondary'}>{status}</span>}/>
                    </div>
                </>
            )
        }if(name === 'popupShow'){
            this.updateTemplateValue(fields, childprops);
        }
    }

    initiateEditTemplate = async (e, templateId, curData) => {
        console.log("CURDATA : ",curData);
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": 'GET_EDIT_TEMPLATE',
            "isOtherApiReq": true,
            "Template_ID": templateId,
        }
        let res = await requestApiService.processServerRequest(params, "WebV2", "post");
        if (res.issuccess) {
            let curData = res.data[0];
            this.setState({
                editTemplate: curData
            })
            let components = parseJSON(decodeString(curData['Components']));
            let waComponents = getWAComponents(components);
            if (waComponents['CAROUSEL'] !== undefined) {
                showToast("Carousel templates cannot be updated.", "top-right", "error");
                return;
            }
            if(waComponents['HEADER'] !== undefined && waComponents['HEADER']['format'] !== 'TEXT'){
                this.toggleMediaModal();
            }
        }
    }

    toggleMediaModal = () => {
        this.setState({
            showMediaModal: !this.state.showMediaModal,
        });
    }

    toggleCarouselModal = () => {
        this.setState({
            showCarouselModal : !this.state.showCarouselModal,
        })
    }

    render(){

        let { formData, listFields, page, totalCount, limit, showLoader, langOptions, showMediaModal, editTemplate } = this.state;
        if(listFields == undefined){
            return <></>
        }
        let customFieldConfig = {
            Message:{
                "class": "template-message",
                "popover" : true,
                "decodeWithParse" : true,
                "render" : "msgGroup"
            },
            Name : {
                "render" : "groupName",
                "class": "template-name w-4",
            },
            Language : {
                "render" : "language_value",
            },
            Status : {
                "render" : "status_allocate",
            }
            // updatedon : {
            //     toLocalDate : true,
            //     dateformat : "dd mmm yyyy"
            // }
        };
        let headerFieldConfig = {
            Name : {
                "class" : "text-left w-5"
            },
            Template : {
                "class" : "text-left w-4"
            },
            Language : {
                "class" : "text-left w-5"
            },
            Status : {
                "class" : "text-center w-4"
            }
        };
        let searchOptions = [
            {
                name : 'Name',
                placeHolder : 'Search by name'
            }
        ];

        const groupedOptions = cratioStatusFilterOptions;/*[
            {
              label: "Status",
              options: this.statusOptions
            },
            {
              label: "Cratio_Status",
              options: cratioStatusOptions
            }
          ];*/

        let selectOptions = [
            {
                'name' : 'Cratio_Status',
                'options' : groupedOptions,
                'multiple' : false
            },
            /*{
                'name' : 'Category',
                'options' : this.categoryOptions,
                'multiple' : true
            },
            {
                'name' : 'Language',
                'options' : langOptions,
                'multiple' : true
            }*/
        ];
        
        let buttonOptions = [
            {
                name : 'sync_templates',
                label : 'Sync',
                icon : faRotate
            },
            {
                name : 'create_template',
                label : 'Create Template',
                icon : faCirclePlus
            },
            {
                name : 'create_carousel_template',
                label : 'Create Carousel Templates',
                icon : faCirclePlus
            }
        ];

        let customRowConfig = {
            link : {
                onClick : this.initiateEditTemplate,
                condition : "",
                class : "row-link"
            }
        }

        return (
            <Fragment>
                <div className="listview-container templates-listview kv-main-wrapper h100per">
                    <FormHeader
                        searchOptions={searchOptions}
                        selectOptions={selectOptions}
                        buttonOptions={buttonOptions}
                        handleSearch={this.handleSearch}
                        handleSelectChange={this.handleChange}
                        handleBtnClick={this.handleBtnClick}
                    />
                    <div className={'p-2 mb-6'}>
                        <ListTable
                            key={Math.random()}
                            formData={formData}
                            fields={listFields}
                            showRowCount={true}
                            isCheckboxNeeded={true}
                            isCheckInfoNeeded={true}
                            checkBoxPopupData={cratioStatusOptions}
                            spaceBfCell={false}
                            config={customFieldConfig}
                            customRowConfig={customRowConfig}
                            renderElements={this.renderElements}
                            noDataMsg={`Templates not found`}
                            pagination={true}
                            onPageChange={this.onPageChange}
                            currentPage={page}
                            totalCount={totalCount}
                            limit={limit}
                            prefix = {"templates"}
                            customClass={'no-border-table'}
                            headerConfig={headerFieldConfig}
                            formName={this.formname}
                        />
                    </div>
                    <MediaModal 
                        toggleMediaModal={this.toggleMediaModal}
                        template={editTemplate}
                        isOpen={showMediaModal}
                        leadFormDetail={[]}
                    />
                    {this.state.showCarouselModal && (
                        <CarouselModal
                            toggleCarouselModal={this.toggleCarouselModal}
                            isOpen={this.state.showCarouselModal}
                            template={editTemplate}
                        />
                    )}
                </div>
                <Footer/>
        </Fragment>
        )
    }

}

export default Templates;
